import { render, staticRenderFns } from "./OpenChapters.vue?vue&type=template&id=79b89560&"
import script from "./OpenChapters.vue?vue&type=script&lang=js&"
export * from "./OpenChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports